<template>
  <span
    class="collapse-button"
    @click="onClick"
  >
    <span
      v-if="showExpandLabel"
      class="collapse-button__text"
    >
      {{ $t(expandLabelKey) }}
    </span>
    <span
      v-if="showCollapseLabel"
      class="collapse-button__text"
    >
      {{ $t(collapseLabelKey) }}
    </span>
    <i
      aria-hidden="true"
      class="collapse-button__icon"
      :class="getIconClass()"
    />
  </span>
</template>

<script>

const ICONS = {
  normal: {
    open: 'down',
    close: 'up',
  },
  side: {
    open: 'right',
    close: 'left',
  },
};

export default {
  props: {
    /**
     * Valor booleano onde "true" indica expandido/visível.
     */
    value: {
      type: Boolean,
      default: false,
    },
    sideArrows: {
      type: Boolean,
      default: false,
    },
    collapseLabelKey: {
      type: String,
    },
    expandLabelKey: {
      type: String,
    },
  },
  computed: {
    showExpandLabel() {
      return !this.value && this.expandLabelKey !== undefined;
    },
    showCollapseLabel() {
      return this.value && this.collapseLabelKey !== undefined;
    },
  },
  methods: {
    onClick() {
      this.$emit('input', !this.value);
    },
    getIconClass() {
      const iconSet = this.sideArrows ? ICONS.side : ICONS.normal;
      return `fa fa-angle-${this.value !== false ? iconSet.close : iconSet.open}`;
    },
  },
};
</script>

<style lang="sass" scoped>
.collapse-button
  cursor: pointer
  user-select: none
  &__text
    font-size: 1.2em
  &__icon
    font-size: 1.5em
</style>
